
import context from '~/mixins/context'

export default {
  name: 'BannerWhite',
  mixins: [context],
}
